import Container from '@wearesection/bandai-react-components/atoms/Container';
// import VerticalScrollingMoreGameContainer from '@wearesection/bandai-react-components/organisms/VerticalScrollingMoreGameContainer';
import React, {useEffect, useMemo, useState} from 'react';
import RenderNextImage from '../../atoms/render-next-image';
import {GAME_PARAM_SORT, PLACEHOLDER_IMG} from '~/constants';
import {
  GetRouter,
  handelReturnTag,
  handleConvertToLocaleContentful,
  handleReturnSubtitleLanguage,
  // handleTranslateGameLanauges,
} from '~/utils';
import {Box} from '@mui/material';
import getListGame from '~/pages/games/get-list-game';
import dynamic from 'next/dynamic';
const VerticalScrollingMoreGameContainer = dynamic(
  () =>
    import('@wearesection/bandai-react-components/organisms/VerticalScrollingMoreGameContainer'),
  {ssr: false}
);
const PADDING_COMPONENT: any = {
  '/games': {
    paddingTop: {
      xs: '72px',
      lg: '40px',
    },
    paddingBottom: {
      xs: '72px',
      lg: '80px',
    },
  },
};

interface PropsComponent {
  title?: string;
  locale?: string;
  notFilter?: boolean;
  dataQueryGame?: any;
  paramSort?: any;
  lengthData?: (value: number) => void;
  tagFilter?: any[];
  dataTranslation: any;
}

const LIST_PLATFORM: any[] = [
  'PlayStation 4',
  'Nintendo Switch',
  'PC',
  'Nintendo 3DS XL',
  'XBOX Series X|S',
  'XBOX Series X',
  'XBOX One',
  'XBOX 360',
  'PlayStation 5',
  'Nintendo 3DS',
];
const LIST_GENRE: any[] = [
  'Action',
  'Adventure',
  'Role playing (RPG)',
  'Anime',
  'Arcade classics',
  'Card/RPG',
  'Fighting',
  'First person shooter',
  'Flight/combat',
  'Free-to-play',
  'Horror',
  'Massive multiplayer online (MMO)',
  'Multiplayer online battle arena (MOBA)',
  'Park management',
  'Puzzle',
  'Racing',
  'Real time strategy',
  'Rhythm',
  'Shooting',
  'Simulation',
  'Sports',
  'Strategy',
  'Tactical',
  'Variety',
];

const VerticalScrollingMoreGameContainerOrganisms: React.FC<PropsComponent> = ({
  title,
  locale,
  notFilter = true,
  dataQueryGame,
  paramSort,
  lengthData,
  tagFilter,
  dataTranslation,
}) => {
  const {pathname} = GetRouter();
  const [dataItems, setDataItems] = useState<any[]>([]);
  const [numberSkip, setNumberSkip] = React.useState<number>(0);
  const [numberNoReleaseDate, setNumberNoReleaseDate] = React.useState<number>(0);
  const [totalItem, setTotalItem] = React.useState<number>(1);
  const [queryGame, setQueryGame] = useState<any>({});
  const [sort, setSort] = useState<any>({});
  const [tags, setTags] = useState<any[]>([]);
  // const [dataTranslationProps, setDataTranslationProps] = useState<any[]>([]);

  // Handle get data game filter or more game
  const handleGetDataGames = async (
    locale: string,
    skip: number,
    limit: number,
    query: any = {},
    tags?: any,
    sort: any = 'New to old'
  ) => {
    const newQuery: any = {
      genre: [],
      platform: [],
    };

    // if (tags?.length) {
    //   newQuery['AND'] = [];
    //   tags.map((item: string) => {
    //     if (LIST_PLATFORM.includes(item)) {
    //       newQuery['AND']['platform_contains_some']
    //         ? newQuery['AND']['platform_contains_some'].push(item)
    //         : (newQuery['AND']['platform_contains_some'] = [item]);
    //     }
    //     if (LIST_GENRE.includes(item)) {
    //       newQuery['AND']['genre_contains_some']
    //         ? newQuery['AND']['genre_contains_some'].push(item)
    //         : (newQuery['AND']['genre_contains_some'] = [item]);
    //     }
    //     return null;
    //   });
    // }

    if (tags?.length) {
      tags.map((item: string) => {
        if (LIST_PLATFORM?.includes(item)) {
          newQuery.platform.push(item);
        }
        if (LIST_GENRE?.includes(item)) {
          newQuery.genre.push(item);
        }
      });
      query = newQuery;
    }

    const IMG_ERROR = PLACEHOLDER_IMG;

    // Just checking at locale TW & HK
    if (
      locale?.toLocaleLowerCase()?.includes('hk') ||
      locale?.toLocaleLowerCase()?.includes('tw')
    ) {
      const existing =
        !!query?.genre?.length && query?.genre.some((elm: string) => elm === 'Tactical');
      if (existing) {
        const oldData = [...query?.genre];
        oldData.push('Strategy');
        query = {
          ...query,
          genre: oldData,
        };
      }
    }

    const promises: [ReturnType<typeof getListGame>] = [
      getListGame(
        handleConvertToLocaleContentful(locale as string),
        limit,
        skip,
        query,
        GAME_PARAM_SORT[sort]
      ),
    ];

    const [listNew] = await Promise.all(promises);
    if (listNew && listNew?.items.length > 0) {
      const items = listNew?.items.map(item => {
        return {
          title: item?.title ?? '',
          mainImage:
            item?.gamesFilterThumbnailImage?.media?.url ||
            item?.mastheadBackgroundImage?.media?.url ||
            IMG_ERROR,
          mainImageNext: (
            <RenderNextImage
              src={
                item?.gamesFilterThumbnailImage?.media?.url ||
                item?.mastheadBackgroundImage?.media?.url ||
                IMG_ERROR
              }
              alt={item?.gamesFilterThumbnailImage?.alt || ''}
              width={311}
              height={200}
            />
          ),
          tags: handelReturnTag(item?.platform),
          locale: handleReturnSubtitleLanguage(item?.subtitle || [], locale),
          // locale:
          //   locale !== 'hk-tc' &&
          //   locale !== 'hk-sc' &&
          //   locale !== 'tw-tc' &&
          //   locale !== 'tw-sc' &&
          //   locale !== 'ko-kr'
          //     ? handleReturnSubtitleLanguage(item?.subtitle || [], locale, true) ?? ''
          //     : handleTranslateGameLanauges((item?.subtitle as any) || [], dataTranslation, true) ??
          //       '',
          href: `/${locale}/games/${item?.slug}`,
        };
      });
      const newItem = [...dataItems, ...items];
      setDataItems(newItem);
      setTotalItem(listNew?.total || 0);
      if (listNew.hasOwnProperty('query') && listNew.query?.data_releaseDate_exists_false) {
        setNumberSkip(newItem.length - listNew.query?.data_releaseDate_exists_false)
        setNumberNoReleaseDate(listNew.query?.data_releaseDate_exists_false)
      } else {
        setNumberSkip(numberSkip + items.length)
      }
      lengthData?.(items.length);
    } else {
      setDataItems([]);
      setTotalItem(0);
      lengthData?.(0);
    }
  };

  useEffect(() => {
    setQueryGame(dataQueryGame);
    setDataItems([]);
    setNumberSkip(0);
    setTotalItem(1);
    setTags(tagFilter || []);
    setSort(paramSort);
  }, [dataQueryGame, paramSort, tagFilter, dataTranslation]);

  // useEffect(() => {
  //   setDataTranslationProps(dataTranslation);
  // }, [dataTranslation]);

  const handleLoadMore = () => {
    handleGetDataGames(locale || 'en-SG', 10, numberSkip, queryGame, tags, sort);
  };
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? PADDING_COMPONENT['/games']}>
      <Container>
        <VerticalScrollingMoreGameContainer
          dataItem={dataItems}
          title={title || ''}
          locale={locale || ''}
          notFilter={notFilter}
          onLoadMore={handleLoadMore}
          nextPage={totalItem > dataItems.length - numberNoReleaseDate}
          dataTranslation={dataTranslation}
        />
      </Container>
    </Box>
  );
};

export default VerticalScrollingMoreGameContainerOrganisms;
